import { memo, ReactNode } from 'react';
import { Breadcrumbs } from '../breadcrumbs/Breadcrumbs';
import styles from './Header.module.scss';

export type Props = {
  heading: string;
  subHeading?: string;
  totalNumberOfResults?: number;
  showNumberOfResults?: boolean;
  alternativeSearchSuggestions?: ReactNode;
  correctedSearchTerm?: ReactNode;
};

export const Header = memo(
  ({
    heading,
    subHeading,
    totalNumberOfResults = 0,
    showNumberOfResults = true,
    alternativeSearchSuggestions,
    correctedSearchTerm,
  }: Props) => {
    const totalNumberOfResultsDisplay =
      showNumberOfResults &&
      Number.isInteger(totalNumberOfResults) &&
      totalNumberOfResults >= 0
        ? `(${totalNumberOfResults.toLocaleString('en')})`
        : '';

    return (
      <header className={styles.heading}>
        <Breadcrumbs />
        <div className={styles.heading__copy}>
          <h1 tabIndex={-1}>
            <span
              data-testid="heading-term"
              // eslint-disable-next-line jsx-a11y/aria-role
              role="text"
              className={styles.heading__main}
            >{`${heading} `}</span>
            {subHeading && (
              <span
                aria-hidden="true"
                data-testid="sub-heading"
                className={styles.heading__filters}
              >
                {subHeading}
              </span>
            )}
          </h1>
          <span
            className={styles.heading__count}
            data-testid="heading-num-results"
          >
            {totalNumberOfResultsDisplay}
          </span>
        </div>
        {correctedSearchTerm}
        {alternativeSearchSuggestions}
      </header>
    );
  }
);

Header.displayName = 'Header';

export default Header;
